<template>
    <div class="container">
        <!-- Page title -->
        <div class="pt-5 pb-5">
            <h1 class="m-0">Transportaanvraag</h1>
        </div>
        <!-- End Page title -->

        <div class="row">
            <div class="col-md-3">
                <!-- Sidebar -->
                <sidebar></sidebar>
                <!-- End Sidebar -->
            </div>
            <div class="col-md-9">
                <div class="panel">
					<p class="mb-4">
						Transportaanvraag: de aanvraag van een transport tussen 2 posten, tussen post en Centraal Magazijn (en omgekeerd), tussen post en leverancier (en omgekeerd), tussen post en hersteldienst (en omgekeerd), tussen verschillende diensten.
					</p>
					<div class="alert alert-warning mb-5">
						Bij dringend transport, gelieve eerst dienst aankoop & logistiek te contacteren (058/60.39.22 of dringendtransport@brandweerwesthoek.be)
					</div>

                    <form @submit.prevent="submit" ref="transportRequestForm">
						<h3 class="mb-4">Ophaling</h3>

						<div class="form-group">
							<label>Ophaaladres</label>
							<select v-model="form.from_station" class="form-control">
								<option
									v-for="station in stations"
									:key="station.id"
									:value="station.id"
								>{{ station.title }}</option>
								<option value="other">Andere</option>
							</select>
							<form-errors :errors="errors['quantity']"></form-errors>
						</div>

						<template v-if="form.from_station == 'other'">
							<div class="form-group">
								<label>Adreslijn</label>
								<input type="text" class="form-control" v-model="form.from_address" />
								<form-errors :errors="errors['from_address']"></form-errors>
							</div>

							<div class="form-group">
								<label>Postcode</label>
								<input type="text" class="form-control" v-model="form.from_postal_code" />
								<form-errors :errors="errors['from_postal_code']"></form-errors>
							</div>

							<div class="form-group">
								<label>Gemeente</label>
								<input type="text" class="form-control" v-model="form.from_city" />
								<form-errors :errors="errors['from_city']"></form-errors>
							</div>
						</template>

						<div class="form-group">
                            <label>Contactpersoon</label>
                            <input type="text" class="form-control" v-model="form.from_contact" />
                            <form-errors :errors="errors['from_contact']"></form-errors>
                        </div>

						<div class="form-group">
                            <label>Telefoonnummer/ mail contact</label>
                            <input type="text" class="form-control" v-model="form.from_contact_phone" />
                            <form-errors :errors="errors['from_contact_phone']"></form-errors>
                        </div>

						<h3 class="mb-4 mt-5">Omschrijving transport</h3>

						<div class="form-group">
                            <label>Palletten</label>
                            <input type="text" class="form-control" v-model="form.contents_pallets" />
                            <form-errors :errors="errors['contents_pallets']"></form-errors>
                        </div>

						<div class="form-group">
                            <label>Grote dozen (niet op pallet)</label>
                            <input type="text" class="form-control" v-model="form.contents_big_boxes" />
                            <form-errors :errors="errors['contents_big_boxes']"></form-errors>
                        </div>

						<div class="form-group">
                            <label>Kleine dozen (niet op pallet)</label>
                            <input type="text" class="form-control" v-model="form.contents_small_boxes" />
                            <form-errors :errors="errors['contents_small_boxes']"></form-errors>
                        </div>

						<div class="form-group">
                            <label>Ander</label>
                            <input type="text" class="form-control" v-model="form.contents_other" />
                            <form-errors :errors="errors['contents_other']"></form-errors>
                        </div>

						<h3 class="mb-4 mt-5">Levering</h3>

						<div class="form-group">
							<label>Leveradres</label>
							<select v-model="form.to_station" class="form-control">
								<option
									v-for="station in stations"
									:key="station.id"
									:value="station.id"
								>{{ station.title }}</option>
								<option value="other">Andere</option>
							</select>
							<form-errors :errors="errors['quantity']"></form-errors>
						</div>

						<template v-if="form.to_station == 'other'">
							<div class="form-group">
								<label>Adreslijn</label>
								<input type="text" class="form-control" v-model="form.to_address" />
								<form-errors :errors="errors['to_address']"></form-errors>
							</div>

							<div class="form-group">
								<label>Postcode</label>
								<input type="text" class="form-control" v-model="form.to_postal_code" />
								<form-errors :errors="errors['to_postal_code']"></form-errors>
							</div>

							<div class="form-group">
								<label>Gemeente</label>
								<input type="text" class="form-control" v-model="form.to_city" />
								<form-errors :errors="errors['to_city']"></form-errors>
							</div>
                        </template>

						<div class="form-group">
                            <label>Contactpersoon</label>
                            <input type="text" class="form-control" v-model="form.to_contact" />
                            <form-errors :errors="errors['to_contact']"></form-errors>
                        </div>

						<div class="form-group">
                            <label>Telefoonnummer contactpersoon ter plaatse</label>
                            <input type="text" class="form-control" v-model="form.to_contact_phone" />
                            <form-errors :errors="errors['to_contact_phone']"></form-errors>
                        </div>

						<h3 class="mb-4 mt-5">Opmerkingen</h3>

						<div class="form-group">
                            <label>Opmerking (data, afmetingen …)</label>
                            <textarea type="text" class="form-control" v-model="form.notes" rows="3"></textarea>
                            <form-errors :errors="errors['notes']"></form-errors>
                        </div>

						<div class="form-group">
							<button 
								v-if="!showUploadForm"
								type="button"
								class="btn btn--accent btn--sm"
								@click.prevent="showUploadForm = true"
							>
								Bijlage toevoegen
							</button>
							<template v-else>
								<vue-dropzone
									ref="dz"
									id="dropzone"
									:options="dropzoneOptions"
									@vdropzone-complete="fileUploaded"
								></vue-dropzone>
							</template>
						</div>

                        <div class="d-flex">
                            <button class="btn btn--accent ml-auto" type="submit">
                                <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="submitting"></i> Indienen
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	components: {
		vueDropzone: vue2Dropzone,
	},
    data() {
        return {
            submitting: false,
			stations: [],
			showForm: true,
            form: {
                from_station: null,
                from_address: null,
                from_postal_code: null,
                from_city: null,
                from_contact: null,
                from_contact_phone: null,
				contents_pallets: null,
				contents_big_boxes: null,
				contents_small_boxes: null,
				contents_other: null,
                to_station: null,
                to_address: null,
                to_postal_code: null,
                to_city: null,
                to_contact: null,
                to_contact_phone: null,
                notes: null,
                attachments: [],
            },
			dropzoneOptions: {
				url: process.env.VUE_APP_BASE_API_URL + '/uploads',
				thumbnailWidth: 150,
				maxFilesize: 5,
				headers: {
					Authorization: 'Bearer ' + this.$store.getters.token,
				},
			},
            errors: {},
			showUploadForm: false,
        };
    },
    computed: {
        categoryList() {
            return this.$store.getters.categoryList;
        }
    },
	mounted() {
		this.fetchStations()
	},
    methods: {
		fetchStations() {
			this.$http.get('/stations')
				.then((res) => {
					this.stations = res.data.data
				})
				.catch((err) => {
					console.log(err)
				});
		},

		openInNewTab(href) {
			Object.assign(document.createElement('a'), {
				target: '_blank',
				rel: 'noopener noreferrer',
				href: href,
			}).click();
		},

        submit() {
            if (this.submitting) {
                return;
            }

            this.submitting = true;

            this.$http
                .post("/transport-requests", this.form)
                .then(res => {
                    console.log(res);

                    this.$root.$emit("notify", {
                        type: "success",
                        text: res.data.message
                    });

                    this.submitting = false;

                    this.errors = {};

					window.setTimeout(() => {
						this.openInNewTab(res.data.redirectUrl)
					}, 4500)

					this.resetForm()
                })
                .catch(err => {
                    console.log(err.response);
                    this.submitting = false;

                    if (err.response.status == 422) {
                        // Error message
                        // if (err.response.data.message) {
                        //     this.$root.$emit("notify", {
                        //         type: "error",
                        //         text: err.response.data.message
                        //     });
                        // }

                        // Errors
                        if (err.response.data.errors) {
                            this.errors = err.response.data.errors;
                        }
                    }
                });
        },

		resetForm() {
			this.form.from_station = null
			this.form.from_address = null
			this.form.from_postal_code = null
			this.form.from_city = null
			this.form.from_contact = null
			this.form.from_contact_phone = null
			this.form.contents_pallets = null
			this.form.contents_big_boxes = null
			this.form.contents_small_boxes = null
			this.form.contents_other = null
			this.form.to_station = null
			this.form.to_address = null
			this.form.to_postal_code = null
			this.form.to_city = null
			this.form.to_contact = null
			this.form.to_contact_phone = null
			this.form.notes = null
			this.form.attachments = []
		},

		fileUploaded(file) {
			console.log('file uploaded', file)
			let response = JSON.parse(file.xhr.response)
			this.form.attachments.push(response.id)
		},
		fileSelected(file) {
			this.$emit('file-selected', file)
		},
		deleteFile(file, index) {
			if (
				window.confirm(
					'Bent u zeker dat u deze bijlage wil verwijderen? Dit is een actie die niet ongedaan kan gemaakt worden.',
				)
			) {
				this.$http
					.delete(
						'/cart/items/' +
							this.item.id +
							'/attachments/' +
							file.id,
					)
					.then((res) => {
						console.log(res)
						this.item.files.splice(index, 1)
					})
					.catch((err) => {
						console.log(err)
					})
			}
		},
    }
};
</script>
